var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loaded)?_c(_vm.layout,{tag:"component"},[_c('router-view')],1):_c('div',{staticClass:"full-height sm-p-t-50 align-items-center d-md-flex"},[_c('div',{staticClass:"col-md-12 text-center"},[_c('div',{staticClass:"progress-circle-indeterminate m-t-45"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }